<template>
  <div id="couponlists">
    <BottomBar />
    <div v-if="lists[0] && !empty" class="main">
      <div class="top">{{ lists.length }} 张学习券</div>
      <div class="coupon-list">
        <Coupon
          v-for="(value, key) in lists"
          :key="key"
          :is-list-view="true"
          :isShowButton="true"
          :coupon="value"
        />
      </div>
    </div>
    <div v-else-if="!empty" class="center">
      <inline-loading />
    </div>
    <div v-else-if="empty" class="center empty">
      <div class="text">
        <h1>暂无学习券</h1>
        <h2>
          您可以
          <router-link to="/courses" tag="a">看看直播课</router-link>，或
          <router-link to="/" tag="a">返回首页</router-link>。
        </h2>
      </div>
    </div>
  </div>
</template>
<script>
import BottomBar from "@/components/public/footer"
import Coupon from "@/components/public/Coupon.vue"
export default {
  name: "Couponlists",
  components: {
    Coupon,
    BottomBar,
  },
  data() {
    return {
      lists: "",
      empty: false,
      courseTypes: {
        0: "通用",
        1: "单一约课上门",
        2: "单一主题课",
        3: "约课上门",
        4: "主题课",
        5: "游学",
        6: "单一游学",
        7: "海外游学",
        8: "国内冬夏令营",
        9: "短途游学",
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$axios(window.PHP_ROOT + "/index/Coupon/my/")
        .then(({ data }) => {
          if (data[0]) {
            this.lists = data
            this.lists.forEach(item => {
              item.display_time = `${this.$moment(item.deadline * 1000).format(
                "YYYY 年 M 月 D 日",
              )}`
              if (item.type == 0) {
                item.title = "通用学习券"
              } else if (item.type == 1 || item.type == 2 || item.type == 6) {
                item.title = `${item.name}学习券`
              } else {
                item.title = `${this.courseTypes[item.type]}学习券`
              }
              if (item.condition == 2) {
                if (item.type == 6) {
                  item.content = "抵用任意 1 次课程"
                } else if (item.type == 1 || item.type == 2 || item.type == 6) {
                  item.content = `抵用 1 次${item.name}课程`
                } else {
                  item.content = `抵用 1 次${this.courseTypes[item.type]}课程`
                }
              } else {
                if (item.type == 6) {
                  item.content = `支付任意课程时抵扣 ${item.amount} 学分`
                } else if (item.type == 1 || item.type == 2 || item.type == 6) {
                  item.content = `支付${item.name}课程时抵扣 ${item.amount} 学分`
                } else {
                  item.content = `支付${this.courseTypes[item.type]}课程时抵扣 ${item.amount} 学分`
                }
              }
            })
          } else {
            this.empty = true
          }
        }).catch(err => this.$toastError(err))
    },
  },
}
</script>
<style type="text/css" lang="scss">
// @import "../../../static/css/public.scss";
@import "../../../static/css/coupon.scss";
.center {
  display: flex;
  align-items: center;
  text-align: center;
  height: 100vh;
  justify-content: space-around;
  .text {
    width: 100%;
    h1 {
      font-size: 25px;
      color: $black;
      font-weight: 500;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 15px;
      color: $black;
      font-weight: 300;
      span {
        color: $red;
        font-weight: 400;
        &:active {
          opacity: 0.7;
        }
      }
    }
  }
}

#couponlists {
  min-height: 100vh;
  $bgd: #fff;
  background: $bgd;
  .top {
    font-size: 20px;
    font-weight: 500;
    position: fixed;
    background: white;
    border-bottom: 1px solid #eee;
    width: 100%;
    @include avenir-demi();
    top: 0;
    left: 0;
    z-index: 10;
    padding: 35px 5% 10px 5%;
  }

  .main {
    width: 100%;
    margin: auto;
    height: 100%;
    box-sizing: border-box;
    padding: 75px 5% 0 5%;
    padding-bottom: $bottom-bar;
    padding-bottom: $iphone-x-bottom-bar;
  }

  .empty {
    padding-bottom: 15vh;
    height: 100vh;
  }
}
</style>
